export default {
  s: '%d secondo',
  smicro: '%d s',
  smid: '%d sec',

  ss: '%d secondi',
  ssmicro: '%d s',
  ssmid: '%d sec',

  m: '%d minuto',
  mmicro: '%d m',
  mmid: '%d min',

  mm: '%d minuti',
  mmmicro: '%d m',
  mmmid: '%d min',

  h: '%d ora',
  hmicro: '%d h',
  hmid: '%d ora',

  hh: '%d ore',
  hhmicro: '%d h',
  hhmid: '%d ore',

  d: '%d giorno',
  dmicro: '%d g',
  dmid: '%d giorno',

  dd: '%d giorni',
  ddmicro: '%d g',
  ddmid: '%d giorni',
};
